import React from 'react'

import { getStaticImage } from 'utils/statics'

const HandleRow = ({ handleClick, text = '', spanClassName = '', type }) => {
  return (
    <span className={spanClassName} onClick={handleClick}>
      <img src={getStaticImage(`/icons/orange-brand/icon-${type}.svg`)} alt={type} />
      <span>{text}</span>
    </span>
  )
}

export default HandleRow
